export const UNKNOWN_FACET_KEY = '__unknown__';
